<div class="chemicals-attached-container">
    <div class="chemicals-attached-item-container">
        <div class="chemicals-attached-item-input-container">
            <mat-form-field appearance="outline" class="chemicals-attached-form-field">
                <mat-label>Chemicals attached</mat-label>
                <input matInput #chemicalsAttachedInput [(ngModel)]="chemicalsAttached"
                    class="chemicals-attached chemicals-attached-item-input"
                    (keyup.enter)="updateChemicalsAttached($event)" (keyup.escape)="cancelUpdate()"
                    (blur)="updateChemicalsAttached($event)" />
                <mat-icon matSuffix (mousedown)="clearChemicalsAttachedInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div class="chemicals-attached-info chemicals-attached-info-text">
        Please disclose any chemicals that were attached, entrapped or adsorbed, to modify surface properties in this material (such as ployvinylpyrrolidone, polyvinyl alcohol, etc.)
    </div>
</div>